<template>
  <section class="form-box">
    <transition name="fadeIn">
      <GuestbookForm
        :activeGuestInformation="activeGuestInformation"
        :secondLang="secondLang"
        :activeLanguage="activeLanguage"
        :cookieExists="cookieExists"
        :box="box"
        v-if="isActive"
        @closeModal="handleCloseModal"
      />
    </transition>
    <div
      class="form-wrapper"
      :style="{ color: box.textColor, background: box.formColor }"
      @click="handleOpenModal(box.email)"
    >
      <div
        class="form-image"
        :style="{
          'background-image': `linear-gradient(0deg, rgba(255, 255, 255, 0.1) -15%, ${box.formColor} 95%), url(${box.backgroundImage})`,
        }"
      ></div>
      <div class="form-title">
        {{ isSecLangActive ? box.titleSec : box.title }}
      </div>
      <div class="form-table">
        <div class="form-table__item">
          <div class="form-table__item--checkbox">
            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                :fill="box.textColor"
                d="M30.625 0H4.375C1.96875 0 0 1.96875 0 4.375V30.625C0 33.0312 1.96875 35 4.375 35H30.625C33.0312 35 35 33.0312 35 30.625V4.375C35 1.96875 33.0312 0 30.625 0ZM15.3125 27.1556L7.20344 19.0466L10.2966 15.9534L15.3125 20.9694L25.7972 10.4847L28.8903 13.5778L15.3125 27.1556Z"
              />
            </svg>
          </div>
          <div
            class="form-table__item--line"
            :style="{ 'background-color': box.textColor }"
          ></div>
        </div>
        <div class="form-table__item">
          <div
            class="form-table__item--checkbox-inactive"
            :style="{ 'border-color': box.textColor }"
          ></div>
          <div
            class="form-table__item--line"
            :style="{ 'background-color': box.textColor }"
          ></div>
        </div>
      </div>
      <div class="form-button">
        <button
          class="gbBtn"
          :style="{ color: box.formColor, background: box.textColor }"
        >
          <div class="gbBtn-text">
            <span v-if="isSecLangActive">{{
              box.buttonTextSec || "SEE OUR SELECTION"
            }}</span>
            <span v-else>{{ box.buttonText || "SEE OUR SELECTION" }}</span>
          </div>
          <svg
            class="gbBtn-bell"
            width="25"
            height="19"
            viewBox="0 0 25 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :fill="box.formColor"
              d="M14.0625 3.24902V2.34375H14.8438C15.2754 2.34375 15.625 1.99414 15.625 1.5625V0.78125C15.625 0.349609 15.2754 0 14.8438 0H10.1562C9.72461 0 9.375 0.349609 9.375 0.78125V1.5625C9.375 1.99414 9.72461 2.34375 10.1562 2.34375H10.9375V3.24902C5.63916 4.00928 1.5625 8.55371 1.5625 14.0625H23.4375C23.4375 8.55371 19.3608 4.00928 14.0625 3.24902ZM24.2188 15.625H0.78125C0.349609 15.625 0 15.9746 0 16.4062V17.9688C0 18.4004 0.349609 18.75 0.78125 18.75H24.2188C24.6504 18.75 25 18.4004 25 17.9688V16.4062C25 15.9746 24.6504 15.625 24.2188 15.625Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import "../../vue-awesome-icons";
import bus from "@/bus.js";
import GuestbookForm from "../GuestbookForm/GuestbookForm";

export default {
  props: {
    box: Object,
    customFonts: Object,
    cookieExists: [String],
    activeLanguage: String,
    secondLang: Boolean,
    activeGuestInformation: Object,
  },
  components: {
    GuestbookForm,
  },
  computed: {
    isSecLangActive() {
      return this.secondLang && this.cookieExists;
    },
  },
  data() {
    return {
      activeGuestTemp: "",
      isActive: false,
    };
  },
  watch: {
    $route: function () {
      if (window.location.hash == "") {
        this.$store.state.currentPrice = 0;
        this.$store.state.activeServices = new Set();
        this.handleCloseModal();
      }
    },
  },
  mounted() {
    this.activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
  },
  methods: {
    handleCloseModal: function () {
      window.location.hash = "";
      this.isActive = false;
      bus.$emit("bodyOverflow", false);
    },
    handleOpenModal: function () {
      window.location.hash = "productsOrder";
      this.isActive = true;
      bus.$emit("bodyOverflow", true);
    },
  },
};
</script>
<style scoped>
.form-box {
  height: 100%;
}
.form-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* float: left; */
  /* width: 320px; */
  width: 100%;
  /* margin: 10px; */
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

.form-image {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  z-index: 2;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.form-title {
  font-size: 1.25rem;
  font-weight: 500; /* Medium */
  height: 25%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
}

.form-table {
  display: flex;
  width: 290px;
  height: 50%;
  flex-direction: column;
  border-radius: 8px;
  display: flex;
  justify-content: space-evenly;
  z-index: 3;
}

.form-table__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.form-table__item--line {
  width: 200px;
  height: 6px;
}
.form-table__item--checkbox-inactive {
  width: 35px;
  height: 35px;
  border: 4px solid;
  border-radius: 5px;
}

.form-button {
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  text-align: center;
  z-index: 3;
}

.gbBtn {
  height: 45px;
  margin: auto;
  border: 2px solid transparent;
  width: calc(100% - 26px);
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gbBtn-text {
  display: flex;
  font-size: 100%;
  justify-content: center;
  align-items: center;
}

.gbBtn-bell {
  position: relative;
  top: -2px;
  left: 30px;
}
</style>
